var map = {
	"./InlineSvg": 8,
	"./InlineSvg.jsx": 8,
	"./Notify": 146,
	"./Notify.jsx": 146,
	"./Period/Period": 62,
	"./Period/Period.jsx": 62,
	"./Price/Description": 26,
	"./Price/Description.jsx": 26,
	"./Price/Price": 63,
	"./Price/Price.jsx": 63,
	"./Price/Pro": 65,
	"./Price/Pro.jsx": 65,
	"./Price/Standart": 64,
	"./Price/Standart.jsx": 64,
	"./Rate/Rate": 147,
	"./Rate/Rate.jsx": 147,
	"./icons/Copy": 66,
	"./icons/Copy.jsx": 66,
	"./icons/ShareIcon": 37,
	"./icons/ShareIcon.jsx": 37,
	"./icons/menu/Services": 67,
	"./icons/menu/Services.jsx": 67,
	"./icons/menu/Сервисы": 148,
	"./icons/menu/Сервисы.svg": 148,
	"./icons/sub_menu/Burger": 68,
	"./icons/sub_menu/Burger.jsx": 68,
	"./icons/sub_menu/Info": 34,
	"./icons/sub_menu/Info.jsx": 34,
	"./icons/sub_menu/Settings": 69,
	"./icons/sub_menu/Settings.jsx": 69,
	"./icons/sub_menu/Users": 70,
	"./icons/sub_menu/Users.jsx": 70,
	"./icons/sub_menu/cards/MagicBall": 71,
	"./icons/sub_menu/cards/MagicBall.jsx": 71,
	"./icons/sub_menu/promotion/Email": 72,
	"./icons/sub_menu/promotion/Email.jsx": 72,
	"./icons/sub_menu/promotion/Search": 73,
	"./icons/sub_menu/promotion/Search.jsx": 73,
	"./icons/sub_menu/promotion/Social": 74,
	"./icons/sub_menu/promotion/Social.jsx": 74,
	"./icons/sub_menu/services/Analytics": 75,
	"./icons/sub_menu/services/Analytics.jsx": 75,
	"./icons/sub_menu/services/CRM": 96,
	"./icons/sub_menu/services/CRM.jsx": 96,
	"./icons/sub_menu/services/Design": 97,
	"./icons/sub_menu/services/Design.jsx": 97,
	"./icons/sub_menu/services/DesignPro": 149,
	"./icons/sub_menu/services/DesignPro.jsx": 149,
	"./icons/sub_menu/services/LogoUpload": 76,
	"./icons/sub_menu/services/LogoUpload.jsx": 76,
	"./icons/sub_menu/services/MainBtn": 77,
	"./icons/sub_menu/services/MainBtn.jsx": 77,
	"./icons/sub_menu/services/NFC": 78,
	"./icons/sub_menu/services/NFC.jsx": 78,
	"./icons/sub_menu/services/PersonalLink": 79,
	"./icons/sub_menu/services/PersonalLink.jsx": 79,
	"./icons/sub_menu/services/Promotion": 80,
	"./icons/sub_menu/services/Promotion.jsx": 80,
	"./icons/sub_menu/services/Reviews": 98,
	"./icons/sub_menu/services/Reviews.jsx": 98,
	"./menu/Link": 10,
	"./menu/Link.jsx": 10,
	"./menu/Menu": 150,
	"./menu/Menu.jsx": 150,
	"./menu/SubMenu": 28,
	"./menu/SubMenu.jsx": 28,
	"./menu/sub_menu": 6,
	"./menu/sub_menu/": 6,
	"./menu/sub_menu/Account": 47,
	"./menu/sub_menu/Account.jsx": 47,
	"./menu/sub_menu/App": 46,
	"./menu/sub_menu/App.jsx": 46,
	"./menu/sub_menu/CardSettings": 50,
	"./menu/sub_menu/CardSettings.jsx": 50,
	"./menu/sub_menu/Cards": 51,
	"./menu/sub_menu/Cards.jsx": 51,
	"./menu/sub_menu/Error": 45,
	"./menu/sub_menu/Error.jsx": 45,
	"./menu/sub_menu/GoPro": 54,
	"./menu/sub_menu/GoPro.jsx": 54,
	"./menu/sub_menu/LogoUpload": 55,
	"./menu/sub_menu/LogoUpload.jsx": 55,
	"./menu/sub_menu/MainBtn": 57,
	"./menu/sub_menu/MainBtn.jsx": 57,
	"./menu/sub_menu/MainMenu": 53,
	"./menu/sub_menu/MainMenu.jsx": 53,
	"./menu/sub_menu/PersonalLink": 56,
	"./menu/sub_menu/PersonalLink.jsx": 56,
	"./menu/sub_menu/ProBar": 52,
	"./menu/sub_menu/ProBar.jsx": 52,
	"./menu/sub_menu/Promotion": 49,
	"./menu/sub_menu/Promotion.jsx": 49,
	"./menu/sub_menu/Services": 48,
	"./menu/sub_menu/Services.jsx": 48,
	"./menu/sub_menu/Settings": 44,
	"./menu/sub_menu/Settings.jsx": 44,
	"./menu/sub_menu/index": 6,
	"./menu/sub_menu/index.jsx": 6,
	"./router": 4,
	"./router.js": 4
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;